// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QHR2","top":"styles_top__1p8Re","left":"styles_left__2qnlX","description":"styles_description__2Epjj"};